/** Embedded traceability experience (side menu + iframe page). */
export const KNOW_YOUR_CHICKEN_URL = 'https://knowyourfarmer.countrychickenco.in/';
export const KNOW_YOUR_CHICKEN_PATH = '/v2/know-your-chicken';

/** Footer "Our Products" — v2 catalog category URLs. */
export const FOOTER_PRODUCT_LINKS = [
  { label: 'Eggs', path: '/v2/catalog?category=Eggs' },
  { label: 'Pickles', path: '/v2/catalog?category=Pickles' },
  { label: 'Mutton', path: '/v2/catalog?category=Mutton' },
  { label: 'BTB Chicken', path: '/v2/catalog?category=BTB+Chicken' },
  { label: 'Country Chicken (Natukodi)', path: '/v2/catalog?category=Country+Chicken+%28Natukodi%29' },
  { label: 'All Products', path: '/v2/catalog' },
];

/** Know Us — v2 static pages (no About Us). */
export const KNOW_US_LINKS = [
  { label: 'Our Stores', path: '/v2/stores' },
  { label: 'Contact Us', path: '/v2/contact' },
  { label: 'Terms And Conditions', path: '/v2/terms' },
  { label: 'Privacy Policy', path: '/v2/privacy' },
  { label: 'Cancellation / Refund Policy', path: '/v2/refund' },
];

/** Legal / support links for mobile side menu (Know Us without Our Stores). */
export const SIDE_MENU_LEGAL_LINKS = KNOW_US_LINKS.filter(
  (link) => link.path !== '/v2/stores',
);

export const SOCIAL_LINKS = [
  { label: 'Facebook', url: 'https://www.facebook.com/Countrychickenco/' },
  { label: 'Instagram', url: 'https://www.instagram.com/countrychickenco/' },
  { label: 'WhatsApp', url: 'https://whatsapp.com' },
  { label: 'LinkedIn', url: 'https://www.linkedin.com/company/countrychickenco/' },
];
